module.exports = __webpack_public_path__ + "static/media/browserconfig.4bda0c09.xml";